<!--首页-->
<template>
  <div>
    <div class="box">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="activity-detail-top" v-if="row.bg_show">
            <div class="top-info">
              <div class="info-top-box">
                <!--<img :src="row.pic_url" alt srcset />-->
                <div class="activity-detail-title">{{row.title}}</div>
                <div class="activity-detail-desc" v-if="this.row.saiqu.id == 648">2024年全国啦啦操社区运动会将于2024年5月至11月以线上形式举行。</div>
                <div class="activity-detail-desc" v-else>{{row.desc}}</div>
              </div>
              <div class="info-main-box">
                <div class="activity-dynamic">
                  <span>动态</span>
                  <span>{{row.bbs_content_count}}</span> ·
                  <span>互动</span>
                  <span>{{row.bbs_activity_count}}</span>
                </div>
                <div class="info-dynamic-items">
                 <div class="dynamic-item" v-if="row.type_id>0" @click="visit('tongzhiwenjian')" v-rblink="{name:'SaiFilesList',query:{saiqu:row.type_id,type:1}}">
                   <img src="../../../assets/images/activity/pic-shuo-1@2x.png" alt />
                   <div class="dynamic-item-title">通知文件</div>
                 </div>
                 <div class="dynamic-item"  v-if="row.type_id>0" @click="visit('richengbiao')" v-rblink="{name:'SaiFilesList',query:{saiqu:row.type_id ,type:2}}" >
                   <img src="../../../assets/images/activity/pic-shuo-10@2x.png" alt />
                   <div class="dynamic-item-title">日程表</div>
                 </div>
                  <div class="dynamic-item"  v-if="row.type_id>0" @click="visit('baoming')"  >
                    <img src="../../../assets/images/activity/pic-shuo-8@2x.png" alt />
                    <div class="dynamic-item-title">立即报名</div>
                  </div>
                  <div class="dynamic-item" v-if="row.type_id>0" @click="visit('shunxu')"  v-rblink="{name:'SaiStartList',query:{saiqu:row.type_id}}">
                    <img src="../../../assets/images/activity/pic-shuo-2@2x.png" alt />
                    <div class="dynamic-item-title">出场顺序</div>
                  </div>
                  <div class="dynamic-item"  v-if="row.type_id>0" @click="visit('chengjichaxun')" v-rblink="{name:'SaiResult',query:{saiqu:row.type_id}}">
                    <img src="../../../assets/images/activity/pic-shuo-4@2x.png" alt />
                    <div class="dynamic-item-title">成绩查询</div>
                  </div>
                  <div class="dynamic-item"   v-if="row.type_id>0"  @click="onShowShisu();visit('shisuanpai')"  >
                    <img src="../../../assets/images/activity/pic-shuo-9@2x.png" alt />
                    <div class="dynamic-item-title">食宿安排</div>
                  </div>
                  <div class="dynamic-item" v-show="row.saiqu.xinxihedui_open==1" @click="onInfoConfirm();visit('xinxihedui')">
                    <img src="../../../assets/images/activity/icon-xinxihedui.png" alt />
                    <div class="dynamic-item-title">信息核对</div>
                  </div>
                  <div class="dynamic-item"  @click="onResults();visit('chengjicexiazai')" >
                    <img src="../../../assets/images/activity/pic-shuo-5@2x.png" alt />
                    <div class="dynamic-item-title">成绩册下载</div>
                  </div>
                  <div class="dynamic-item" @click="onZhixuce();visit('zhixucexiazai')">
                    <img src="../../../assets/images/activity/pic-shuo-6@2x.png" alt />
                    <div class="dynamic-item-title">秩序册下载</div>
                  </div>
                  <div class="dynamic-item" @click="onWenjuan();visit('diaocha')" >
                    <img src="../../../assets/images/activity/pic-shuo-7@2x.png" alt />
                    <div class="dynamic-item-title">调查问卷</div>
                  </div>
                  <div class="dynamic-item" @click="onZhibo();visit('zhibo')">
                    <img src="../../../assets/images/activity/pic-shuo-3@2x.png" alt />
                    <div class="dynamic-item-title">直播</div>
                  </div>
                </div>
              </div>
              <div class="info-bottom-box" v-if="false">
                <img src="../../../assets/images/activity/icon-shuo-notice@2x.png" alt />
                <div style="width:1px;height:15px;background:rgba(0,0,0,1);opacity:0.16;"></div>
                <div class="start-immediately">赛事马上开始咯~</div>
              </div>
            </div>
          </div>

          <van-tabs v-model="active" :class="row.bg_show ? 'active-tab': ''" sticky @click="onClick">
            <van-tab v-for="(item,index) in activeTab" :key="index" :type="index">
              <template #title>
                <span class="active-tab-num" v-if="item.num>0">{{item.num}}</span>
                {{item.name}}
              </template>
              <div
                v-for="(item ,i) in row.list.list"
              >
                <div v-rblink="{name:'NewsDetail',query:{id:item.id }}" v-if="item.style=='-1'">
                  <!-- 无图 style==1 -->
                  <NewsItem1 :row="item" v-if="item.pics.length==0"></NewsItem1>
                  <!-- 有图 style==2 -->
                  <NewsItem2 :row="item" v-if="item.pics.length==1"></NewsItem2>
                  <!-- 视频 style==3 -->
                  <NewsItem3 v-if="false"></NewsItem3>
                  <!-- 多图 style==4 -->
                  <NewsItem4 :row="item" v-if="item.pics.length>1"></NewsItem4>
                </div>

                <!-- 小图 style==1 -->
                <Activity1 v-if="item.style=='1'" :content="item" :index="i"></Activity1>

                <!-- 视频 style==2 -->
                <Activity2 v-if="item.style=='2'" :content="item" :index="i"></Activity2>

                <!-- 视频带评论 style==3 -->
                <Activity3
                  v-if="item.style=='3'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event,item,i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event,item,i)"
                  @deleteComment="onDeleteComment($event,i)"
                ></Activity3>

                <!-- 多图带评论 style==4 -->
                <Activity4
                  v-if="item.style=='4'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event,item,i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event,item,i)"
                  @deleteComment="onDeleteComment($event,i)"
                ></Activity4>
                <Activity5
                  v-if="item.style=='5'"
                  :content="item"
                  :index="i"
                  @sendBox="onSendBox($event,item,i)"
                  @loginStatus="onLoginStatus($event)"
                  @deleteActive="onDeleteActive($event,item,i)"
                  @deleteComment="onDeleteComment($event,i)"
                ></Activity5>
              </div>
            </van-tab>
          </van-tabs>
          <div class="comment-bottom" v-if="sendShow">
            <div class="send-comment">
              <van-field v-model="message" :placeholder="placeholder" show-word-limit />
              <div class="send-btn" @click="onCommentSend">发送</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />

<!--    <NavFloatService :id="this.$route.query.id"></NavFloatService>-->
<!--    <div-->
<!--      class="to-form-add"-->
<!--      v-rblink="{name:'ActivityContentForm',query:{'activity_id':this.$route.query.id}}"-->
<!--    >-->
<!--      <img src="../../../assets/images/activity/bg-btn-post@2x.png" alt srcset />-->
<!--    </div>-->
<!--    添加-->
    <NavFloatAdd :id="this.$route.query.id"></NavFloatAdd>
    <NavFloatService @show="showKefu = true"></NavFloatService>
    <NavFloatShare @show="show_share_panel = true"></NavFloatShare>

<!--    <div-->
<!--            style="    top: 7.5rem;"-->
<!--      class="to-form-add"-->
<!--            @click="showKefu=true"-->
<!--    >-->
<!--      <img src="../../../assets/images/activity/bg-kefe-icon.png" alt srcset />-->

<!--    </div>-->

    <van-dialog v-model="showKefu">
      <div style="width: 80%; text-align: center ; margin: 10px auto ;  font-size:14px;">
        <img style="width: 100%;" :src="row.saiqu.erweiimg_pic_url" /> <br/> 请添加赛事联系人微信</div>
    </van-dialog>
 
    <van-dialog v-model="showZhibo"  title="直播二维码" :show-confirm-button="false"  :close-on-click-overlay="true">
      <div style="width: 80%; text-align: center ; margin: 0px auto 20px;  font-size:14px; max-height:400px; overflow-y: scroll;">
        <p>长按保存到相册</p>
        <img :key='imgkey' v-for="(imgrow,imgkey) in row.saiqu.zhibo_pic_urls" style="width: 100%;" :title="imgrow.name" :src="imgrow.url" />
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round  @click="onZhiboDownload" >下载二维码</van-button>
      </div>
    </van-dialog> 


    <van-dialog v-model="shisuShow" title="食宿安排" show-cancel-button cancel-button-text='我知道了' :show-confirm-button="false"  >

            <van-cell-group style="height: 8rem ; overflow-y: scroll">

            <van-divider>酒店信息</van-divider>
                <van-cell
                  title="名称" :value="row.hotel.name ? row.hotel.name:'暂未配置' "
                />
                <van-cell
                  title="地址" :value="row.hotel.address ? row.hotel.address:'暂未配置' "
                />
                <van-cell
                  title="用餐" :value="row.hotel.dinner ? row.hotel.dinner:'暂未配置' "
                />
            <van-divider>赛中车辆信息</van-divider>
                <van-cell
                  title="车辆" :value="row.bus_list.name ? row.bus_list.name:'暂未配置'"
                />
            <van-divider>接站信息</van-divider>
                <van-cell
                  title="接站地点" :value="row.take_list.come_station_name ? row.take_list.come_station_name:'暂未配置'"
                />
                <van-cell
                  title="接站时间" :value="row.take_list.come_date_time ? row.take_list.come_date_time:'暂未配置'"
                />
                <van-cell
                  title="接站车次" :value="row.take_list.come_transcode ? row.take_list.come_transcode:'暂未配置'"
                />
            <van-divider>送站信息</van-divider>
                <van-cell
                  title="送站地点" :value="row.take_list.go_station_name ? row.take_list.go_station_name:'暂未配置'"
                />
                <van-cell
                  title="送站时间" :value="row.take_list.go_date_time ? row.take_list.go_date_time:'暂未配置'"
                />
                <van-cell
                  title="送站车次" :value="row.take_list.go_transcode ? row.take_list.go_transcode:'暂未配置'"
                />

            </van-cell-group>
        </van-dialog>

    <van-action-sheet
      v-model="sheetActiveShow"
      :actions="sheetActiveActions"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onSelect"
    />
<van-action-sheet
  v-model="sheetCommentShow"
  :actions="sheetCommentActions"
  cancel-text="取消"
  close-on-click-action
  @cancel="onSheetCancel"
  @select="onSelect"
/>

    <van-action-sheet
        v-model="ltShow"
        :actions="ltActions"
        cancel-text="取消"
        @select="onLtSelect"
        close-on-click-action
        @cancel="ltShow=false"
    />
 
    <div class="shareShow" v-if="showWxShare" @click="onShareCancel">
      <div>
        <h2>点击分享给好友</h2>
      </div>
    </div>


    <van-popup v-model="show_share_panel" position="bottom" :style="{ height: '30%' }">
      <div class="share-panel">
        <div class="share-title">请选择分享方式</div>
        <!--<div class="share-desc">朋友通过你分享的页面成功报名后，你可获得对应的佣金。佣金可在会员中心-分销订单里查看</div>-->
        <div class="share-ul">
          <div class="share-weixin" @click="shareWeixinFriend">
            <p>微信好友</p>
          </div>
          <div class="share-timeline" @click="shareWeixinTimeLine">
            <p>朋友圈</p>
          </div>
          <div class="share-copy" v-clipboard:copy="copy_text"
               v-clipboard:success="function(){copySuccess();show_share_panel=false }">
            <p>复制链接</p>
          </div>
        </div>
      </div>
    </van-popup>

			<LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
  </div>
</template>
<style scoped>
/* @import '../../assets/style/index.css'; */
.to-form-add {
  width: 1.1rem;
  height: 1.1rem;
  position: fixed;
  right: 0.2rem;
  top: 9rem;
  z-index: 3;
}
.to-form-add img {
  width: 100%;
}
.send-btn {
  width: 1.3rem;
  height: 38px;
  background: linear-gradient(
    90deg,
    rgba(254, 200, 53, 1) 0%,
    rgba(255, 173, 25, 1) 100%
  );
  border-radius: 4px;
  margin-left: 12px;
  line-height: 38px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.send-comment {
  width: 7.1rem;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}
.comment-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.08rem;
  background: rgba(247, 247, 247, 1);
  border: 1px solid rgba(236, 236, 236, 1);
}
.release-time-right {
  display: flex;
}
.icon-zan-comment-box {
  width: 175px;
  height: 38.5px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
}
.activity-place {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}
.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}
.user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-face img {
  height: 32px;
  width: 32px;
}
.user-info {
  margin-left: 5px;
  float: left;
}
.user-info view {
  height: 50px;
  line-height: 50px;
}
.user-names {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.look-info {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  line-height: 17px;
}
.video-bottom {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 5px;
}
.video-box img {
  margin-top: 10px;
  width: 100%;
}
.active-items-title-read {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 58%;
}
.active-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.active-item-pics {
  width: 40%;
}
.active-item-pics img {
  width: 100%;
  height: 1.4rem;
}
.acitve-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.active-itme-read {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.acitve-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
}
.video-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
}
.active-tab {
  margin-top: 0.6rem;
}
.active-tab-num {
  width: 0.34rem;
  height: 0.34rem;
  background: #f05656;
  text-align: center;
  line-height: 0.34rem;
  display: block;
  position: absolute;
  right: -10px;
  top: -10px;
  border-radius: 0.34rem;
  color: #fff;
}
.active-tab >>> .van-tab__text {
  position: relative;
}
.active-tab >>> .van-tabs__nav {
  background: #f8f8f8;
}
.active-tab >>> [class*="van-hairline"]::after {
  border-top: none;
}
.activity-detail-top {
  width: 100%;
  background-size: 100% 4.69rem;
  background: url("../../../assets/images/activity/pic-shuo-top-1@2x.png")
    no-repeat;
  background-size: 100%;
  position: relative;
  overflow: hidden;
}
.top-info {
  width: 6.9rem;
  /*height: 5.3rem;*/
  background: rgba(255, 255, 255, 1);
  border-radius: 7px;
  margin: 2.1rem auto;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
}
.info-top-box {
  /*height: 1.45rem;*/
  padding: 0.26rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
}
.info-top-box img {
  width: 1.08rem;
  height: 1.08rem;
  position: absolute;
  top: -0.36rem;
}
.activity-detail-title {
  font-size: 19px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin: 5px 0;
  /*text-indent: 1.34rem;*/
}
.activity-detail-desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 18px;
}
.info-main-box {
  /* height: 2.4rem; */
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  padding: 0.2rem;
}
.activity-dynamic {
  height: 33px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 33px;
  text-indent: 0.28rem;
}
.info-dynamic-items {
  display: flex;
  /*justify-content: space-between;*/
  /*flex: 1;*/
  /*flex-wrap: nowrap;*/
  /*overflow-y: scroll;*/
  justify-content: flex-start;
  flex-wrap: wrap;
}
.info-dynamic-items .dynamic-item {
  /*min-width: 25%;*/
  min-width: 20%;
  max-width: 20%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
   margin-bottom: 0.1rem;
}
.dynamic-item img {
  width: 0.6rem;
  height: 0.6rem;
  display: block;
  margin-bottom: 0.12rem;
}

.info-bottom-box {
  flex: 1;
  display: flex;
  align-items: center;
}
.info-bottom-box img {
  width: 24px;
  height: 24px;
  display: block;
  margin: 0 0.16rem 0 0.28rem;
}
.start-immediately {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  margin-left: 0.14rem;
}
.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
</style>

<script>
import Vue from "vue";

import jquery from 'jquery';
import { Tab, Tabs, Toast, Field, List, PullRefresh,ActionSheet,Dialog } from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(Toast)
  .use(Field)
  .use(PullRefresh)
  .use(Dialog)
  .use(List).use(ActionSheet);
import Activity1 from "@/components/activity/Activity1.vue";
import Activity2 from "@/components/activity/Activity2.vue";
import Activity3 from "@/components/activity/Activity3.vue";
import Activity4 from "@/components/activity/Activity4.vue";
import Activity5 from "@/components/activity/Activity5.vue";

import LoginDialog from "@/components/LoginDialog.vue";
import NavFloatService from "@/components/NavFloatService.vue";
import NavFloatAdd from "@/components/NavFloatAdd.vue";
import NavFloatShare from "@/components/NavFloatShare.vue";

import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";

import { getTimeFormat } from "../../../utils/date.js";

export default {
  name: "Activity",
  components: {
    Activity1,
    Activity2,
    Activity3,
    Activity4,
    Activity5,
    LoginDialog,
    NavFloatService,
    NavFloatShare,
    NavFloatAdd,
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4
  },
  data: function() {
    return {
      shisuShow:false,
      isLoading: false,
      showKefu: false,
      showZhibo: false,
      showZhibom: true,
      loading: false,
      finished: false,
      loginShow: false,
      sheetActiveShow:false,
      sheetCommentShow:false,
      Loop: null,
      active: 0,
      activeTab: [
        { name: "文件", num: 0, type: -1 },
        { name: "动态", num: 0, type: 0 },
        { name: "图片", num: 0, type: 1 },
        // { name: "视频", num: 0, type: 2 }
      ],
      sheetActiveActions: [{ name: '删除主题' }],
      sheetCommentActions: [{ name: '删除评论' }],
      row: {
        id: 0,
        pic: [],
        pics: [],
        list: [],
        hotel:{},
        take_list:{},
        bus_list:{},
        saiqu:{
          erweiimg_pic_url: '',
          zhibo_pic_urls: []
        }
      },
      params: {
        id: 0,
        type: -1, // -1文件 0动态 1是图片  2是视频
        pageNo: 1
      },
      message: "",
      sendShow: false,
      item: {}, //当前评论的item
      list_index: 0, //当前评论的列表下标
      to_comment_id: 0, //点击评论回复其人的id
      placeholder: "说点什么...",
      touchstartId:0, //长按后的id
      touchstartIndex:0 ,//长按后的下标
      commentIndex:0,//长按后评论下标

      copy_text: '',
      showWxShare: false,
      show_share_panel: false,
      share_data:{},

      ltImgSrc: '',
      ltImgName: '',
      ltActions: [{name: '保存图片'}],

      ltShow: false,
    };
  },
  filters: {
    getTimeFormat: getTimeFormat
  },
  mounted() {
    document.title = "活动";
    this.row.id = this.$route.query.id;
    this.params.id = this.$route.query.id;

    this.params.pageNo = 1;
    this.loading = true;
    this.finished = false;
    this.fetch();
  },
  destroyed() {},
  methods: {

    onLtSelect(item) {
      let that = this;
      switch (item.name) {
        case '保存图片':
          console.log(that.ltImgSrc, that.ltImgName);
          appEvent({
            name: 'downloadPic',
            query: {
              'filename': that.ltImgName,
              'url': that.ltImgSrc
            }
          });
          break;
      }
    },
    onZhibo(){
      let that = this;
      if(this.row.saiqu.zhibo_pic.length > 0){
        // 显示图片
        this.showZhibo = true

          setTimeout(() => {
            jquery('img').each(function () {
              jquery(this).unbind();
              jquery(this).longPress(() => {
                console.log('longPress', jquery(this).attr('src'));
                that.ltImgSrc = jquery(this).attr('src')
                that.ltImgName = jquery(this).attr('title')
                that.ltShow = true;
              });
            })
          }, 500);
        return
      } else if(this.row.saiqu.zhibo_url) {
        rbLink({
          name: 'H5',
          query: {
            url: this.row.saiqu.zhibo_url
          }
        })
      }else{
        Toast('暂未开通!');
      }
    },

    // 信息核对
    onInfoConfirm() {
      // saiConfirmManage
      let that = this;
      rbLink({
        name: 'saiConfirmManage',
        query: {
          saiqu:that.row.saiqu.id
        }
      })
    },
    onWenjuan(){
      if(this.row.saiqu.wenjuanxing_url) {
        rbLink({
          name:'H5',
          query:{
            url: this.row.saiqu.wenjuanxing_url
          }
        })
      } else {
        Toast('暂未开通!');
      }
    },
    onZhiboDownload(){
      if(this.row.saiqu.zhibo_pic_urls.length>0){
        this.download({
          name:this.row.saiqu.name + '直播二维码',
          url:this.row.saiqu.zhibo_pic_urls
        })
      }else{
        Toast('暂未生成!');
      }
    },
    onZhixuce(){
      if(this.row.saiqu.zhixuce_url){
        this.download({
          name:this.row.saiqu.zhixuce_name,
          url:this.row.saiqu.zhixuce_url
        })
      }else{
        Toast('暂未生成!');
      }
    },
    onShowShisu(){
      if(!this.row.show_shisu){
        Toast('本赛区您没有成功的报名记录!');
      }else{
        this.shisuShow=true;
      }

    },
    visit(type){
      let that=this
      console.log('shanchu',this.touchstartId)
      that.$api.get(
        "/api/isai/visit",
        {saiqu:this.row.saiqu.id,
          type:type
        },
        res => { 
        },
        res => {
          Toast(res.msg);
        }
      );


      if(type=='baoming'){
        if(this.row.saiqu.is_jizan==1){
          rbLink(
            {name:'ZSaiApplyFormStep1',query:{saiqu_id:this.row.type_id}}
          )
        }else{
          rbLink(
            {name:'ISaiApplyFormStep1',query:{saiqu_id:this.row.type_id}}
          )
        }
      }
    },
    onResults(){
      if(this.row.saiqu.results_book_url){
        this.download({
          name:this.row.saiqu.results_book_name,
          url:this.row.saiqu.results_book_url
        })
      }else{
        Toast('暂未生成!');
      }
    },
    onShisu(){
      Toast('暂未开通!');
    },
    activeDetele(){
      //删除话题
      let that=this
      console.log('shanchu',this.touchstartId)
      that.$api.get(
        "/api/activity/topicDelete",
        {id:this.touchstartId},
        res => {
          this.row.list.list.splice(this.touchstartIndex,1)
           Toast('删除成功!');
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    CommentDetele(){
      //删除评论
      let that=this
      let id=this.row.list.list[this.touchstartIndex].comment_list[this.commentIndex].id
      that.$api.get(
        "/api/activity/commentDelete",
        {id:id},
        res => {
          this.row.list.list[this.touchstartIndex].comment_list.splice(that.commentIndex,1)
           Toast('删除成功!');
        },
        res => {
          Toast(res.msg);
        }
      );
    },

    onSelect(action,index){
      console.log(action,index)
      switch (action.name){
        case '删除主题':
          this.activeDetele()
        break;
        case '删除评论':
           this.CommentDetele()
        break;
      }
    },
    onSheetCancel() {
      // Toast('取消');
    },
    onDeleteActive(event,item,i){
      //删除主题
      this.touchstartId=item.id
      this.touchstartIndex=i
      this.sheetActiveShow=true
    },
    onDeleteComment(event,i){
      // 删除评论
      console.log(event,i)
      this.touchstartIndex=i
      this.commentIndex=event
      this.sheetCommentShow=true
    },
    onClick(name, title) {
      console.log(name);
      this.params.type = this.activeTab[name].type;
      this.params.pageNo = 1;
      this.fetch();
    },
    toActivityDetail(item) {
      let that = this;
      that.$router.push({
        path: "/activity-activity-detail",
        query: {
          id: item.id
        }
      });
    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/activity/activity",
        that.params,
        res => {
          that.loading = false;

          if (res.data.list.currentpage == 1) {
            that.isLoading = false;
            that.row = res.data;
          } else {
            that.row.list.list = that.row.list.list.concat(res.data.list.list);
          }

          if (res.data.list.list.length == 0) {
            that.finished = true;
          }
          that.params.pageNo += 1;

        that.share_data = res.data.share_data;
        that.copy_text = res.data.share_data.url;


        if (window.isApp()) {
        // if (true) {
          setTimeout(() => {
            jquery('img').each(function () {
              jquery(this).unbind();
              jquery(this).longPress(() => {
                console.log('longPress', jquery(this).attr('src'));
                that.ltImgSrc = jquery(this).attr('src')
                that.ltImgName = jquery(this).attr('title')
                that.ltShow = true;
              });
            })
          }, 500);
          return false;
        }
        },
        res => {
          // Toast(res.msg);

					console.log('没有登录');
					if (res.code == 401 || res.code==402) {
						if(window.isApp()){
							rbLink({
								name:'login','query':{ }
							},'replace');
							return false;
						}
						that.loginShow = true
					}else {
						Toast(res.msg)
					}
        }
      );
    },

			loginSuccess(res){
				console.log('-------登录成功--------',res);
				this.loginShow = false;
				this.fetch();
			},

			loginCancel(){
				console.log('-------取消登录--------');
				// this.loginShow = false;
			},
    onSendBox(event, item, i) {
      // console.log(event)
      this.sendShow = event.sendShow;
      this.to_comment_id = event.comment_.id;
      this.placeholder = event.comment_.user_name
        ? "@" + event.comment_.user_name
        : "说点什么...";
      (this.item = item), (this.list_index = i);
    },
    onLoginStatus(event) {
      this.loginShow = true;
    },
    onCommentSend() {
      let that = this;
      console.log("发送评论", this.item, this.message);
      that.$api.get(
        "/api/activity/commentAdd",
        {
          topic_id: this.item.id,
          content: this.message,
          to_comment_id: this.to_comment_id
        },
        res => {
          console.log(res);
          this.row.list.list[this.list_index].comment_list.push(res.data);
          this.message = "";
        },
        res => {

          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                      {
                        name: "login",
                        query: {}
                      },
                      "replace"
              );
              return false;
            }
            that.loginShow = true
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.fetch();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
       this.loginShow = false;
    },
    showDeleteButton(e) {
      clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
      this.Loop = setTimeout(
        function() {
          console.log(e)
          if(e.is_admin){
            this.activeListId=e.id
            this.sheetActiveShow=true
          }
        }.bind(this),
        800
      );
    },
    emptyTime() {
      clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
    },

    download(file){
      appEvent({
        name: 'downloadFile',
        query: {
          name:file.name,
          url:file.url,
        }
      });
    },



    onShareCancel() {
      this.showWxShare = false;
    },


    shareWeixinFriend() {
      console.log('shareWeixinFriend')
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinFriend',
          query: that.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinTimeLine',
          query: that.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;

      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Activity.vue?1e43b7de